// Mock data for Maheen Kehkasha's Portfolio

export const personalInfo = {
  name: "Maheen Kehkasha",
  title: "Digital Marketer & Social Media Manager",
  location: "Bengaluru, India",
  tagline: "I turn attention into revenue.",
  description: "Digital marketing, SEO, and social media — built into systems that convert. Based in Bengaluru, working with brands everywhere.",
  primarySkill: "Digital Marketer",
  secondarySkill: "Social Media Manager",
  phone: "+91 7899275871",
  email: "connectmaheenk@gmail.com",
  experience: "1+ Years",
  whatsappLink: "https://wa.me/917899275871"
};

export const services = [
  {
    id: 1,
    title: "Web Development",
    description: "MERN & WordPress sites built to convert, not just look good.",
    icon: "Code",
    color: "#7C3AED"
  },
  {
    id: 2,
    title: "SEO",
    description: "Data-driven strategies that earn rankings and traffic that actually buys.",
    icon: "TrendingUp",
    color: "#7C3AED"
  },
  {
    id: 3,
    title: "Social Media",
    description: "Campaigns that build communities, not just follower counts.",
    icon: "Share2",
    color: "#7C3AED"
  },
  {
    id: 4,
    title: "Meta Ads",
    description: "Facebook & Instagram campaigns engineered for ROI.",
    icon: "Target",
    color: "#7C3AED"
  },
  {
    id: 5,
    title: "Design & Branding",
    description: "Visual identity that communicates and converts.",
    icon: "Palette",
    color: "#7C3AED"
  },
  {
    id: 6,
    title: "Technical Setup",
    description: "Domains, hosting, email, infrastructure — fully handled.",
    icon: "Server",
    color: "#7C3AED"
  },
  {
    id: 7,
    title: "Video Editing",
    description: "Short-form reels and social video edited to stop the scroll and drive action.",
    icon: "Video",
    color: "#7C3AED"
  }
];

export const projects = [
  {
    id: 0,
    name: "Sanz International",
    url: "https://sanzedu.com",
    category: "Education",
    challenge: "A decade-old guidance brand needed a digital presence as honest and data-driven as its service — one that converts confused students into booked sessions.",
    approach: "Bold, high-contrast site with clear study-abroad and career-intelligence paths, confident messaging, and a prominent free-session CTA.",
    outcome: "A trustworthy, conversion-focused site that turns student uncertainty into booked consultations.",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/h2p0s2g5_image.png",
    featured: true,
    isNew: true
  },
  {
    id: 1,
    name: "Builder Bro",
    url: "https://builderbro.construction",
    category: "Construction",
    challenge: "Zero visibility",
    approach: "SEO site + local targeting",
    outcome: "Established strong search presence and a steady inbound lead channel",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/4ou14bgk_builderbro.png"
  },
  {
    id: 2,
    name: "Innovative Facades",
    url: "https://innovativefacades.com",
    category: "Architecture",
    challenge: "No showcase",
    approach: "Image-rich, fast portfolio",
    outcome: "Sharper professional image, stronger engagement",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/oqtndpg5_Screenshot%202026-04-13%20141305.png"
  },
  {
    id: 3,
    name: "The Leather Saga",
    url: "https://theleathersaga.com",
    category: "E-commerce",
    challenge: "Needed premium store",
    approach: "Elegant store + smooth checkout",
    outcome: "Premium-positioned store that converts",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/tsvor702_Screenshot%202026-04-13%20141418.png"
  },
  {
    id: 4,
    name: "Kavvi",
    url: "https://kavvi.in",
    category: "Lifestyle",
    challenge: "No digital footprint",
    approach: "Visual-led storytelling site",
    outcome: "Experience that connects with its audience",
    image: "https://images.unsplash.com/photo-1590479773265-7464e5d48118?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: 5,
    name: "Prajwal Constructions",
    url: "https://prajwalconstructions.com",
    category: "Construction",
    challenge: "Dated UX",
    approach: "Full redesign + galleries + inquiry system",
    outcome: "Modernized presence, better engagement",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/yaixisyn_Screenshot%202026-04-13%20141454.png"
  }
];

export const socialMediaClients = [
  {
    id: 1,
    name: "Sanz International",
    category: "Education",
    challenge: "A trusted guidance brand needed a social presence as honest as its service.",
    approach: "Built a consistent content system positioning the brand around data-driven student guidance and free-session conversions.",
    outcome: "A credible, conversion-focused presence that turns student uncertainty into booked consultations.",
    instagram: "https://www.instagram.com/sanz_international/",
    facebook: "#",
    linkedin: "#"
  },
  {
    id: 3,
    name: "Nurture Cave",
    category: "Wellness",
    challenge: "A care-focused brand with no cohesive social identity.",
    approach: "Created a consistent visual and content system around the brand's mission.",
    outcome: "A cohesive presence that builds trust and community.",
    instagram: "https://www.instagram.com/nurturecave_official/",
    facebook: "#",
    linkedin: "#"
  },
  {
    id: 4,
    name: "Dr. Safina Career Psych",
    category: "Personal Brand",
    challenge: "Clinical career psychology getting lost among generic motivational coaching.",
    approach: "Built an authoritative, research-backed content presence with a distinct expert voice.",
    outcome: "A credible personal brand that stands apart from coaching rhetoric.",
    instagram: "https://www.instagram.com/drsafinacareerpsych/",
    facebook: "#",
    linkedin: "#"
  },
  {
    id: 5,
    name: "Builder Bro",
    category: "Construction",
    challenge: "A construction brand with no social presence or inbound from social.",
    approach: "Launched branded content and Meta ad campaigns engineered for qualified leads.",
    outcome: "An active social channel built to generate construction leads.",
    instagram: "https://www.instagram.com/builder_bro_official/",
    facebook: "#",
    linkedin: "#"
  }
];

export const skills = [
  { name: "Social Media Management", category: "marketing", level: 95 },
  { name: "Content Strategy & Planning", category: "marketing", level: 92 },
  { name: "Digital Marketing Strategy", category: "marketing", level: 90 },
  { name: "SEO", category: "marketing", level: 90 },
  { name: "Social Media Marketing", category: "marketing", level: 90 },
  { name: "Video Editing", category: "creative", level: 88 },
  { name: "Content Creation", category: "marketing", level: 88 },
  { name: "Meta Ads", category: "marketing", level: 88 },
  { name: "Brand Building & Personal Branding", category: "marketing", level: 87 },
  { name: "Analytics", category: "marketing", level: 87 },
  { name: "Reels Editing", category: "creative", level: 85 },
  { name: "Community Management", category: "marketing", level: 85 },
  { name: "Google Ads", category: "marketing", level: 85 },
  { name: "Short-Form Video", category: "creative", level: 85 },
  { name: "Email Marketing", category: "marketing", level: 80 }
];

export const navItems = [
  { id: "hero", label: "Home", position: 0 },
  { id: "about", label: "About", position: 1 },
  { id: "experience", label: "Experience", position: 2 },
  { id: "services", label: "Services", position: 3 },
  { id: "projects", label: "Projects", position: 4 },
  { id: "skills", label: "Skills", position: 5 },
  { id: "contact", label: "Contact", position: 6 }
];

export const workExperience = [
  {
    id: 1,
    company: "Sanz International",
    position: "Digital Marketer",
    duration: "2026 – Present",
    location: "Bengaluru, India",
    current: true,
    website: "",
    responsibilities: [
      "Develop and implement digital marketing strategies aligned with business goals.",
      "Manage SEO — keyword research, on-page, technical SEO, and content planning.",
      "Create and manage social campaigns that grow brand awareness and engagement.",
      "Plan, launch, and optimize Meta Ads campaigns focused on leads and conversions.",
      "Monitor website performance and user behavior with analytics tools.",
      "Collaborate with design and content teams on high-performing marketing assets.",
      "Track KPIs and deliver performance reports with actionable insights."
    ],
    color: "#7C3AED"
  },
  {
    id: 2,
    company: "Aril BuilderBro LLP",
    position: "Digital Marketing Executive",
    duration: "January 2025 – December 2025",
    location: "Bengaluru, India",
    current: false,
    website: "builderbro.construction",
    responsibilities: [
      "Managed the company website using WordPress including content updates, landing pages, and SEO improvements.",
      "Implemented on-page SEO strategies such as keyword optimization, meta tags, and internal linking to improve search rankings.",
      "Planned and executed Facebook and Instagram ad campaigns to generate leads for construction services.",
      "Optimized website performance including page speed, mobile responsiveness, and UI improvements.",
      "Created and published marketing content and social media creatives to improve brand visibility.",
      "Monitored campaign performance using Google Analytics and Meta Ads Manager to improve conversions and ROI."
    ],
    color: "#7C3AED"
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Maheen has done an excellent job managing our website and digital marketing. Her SEO strategies and ad campaigns have significantly improved our visibility and lead generation.",
    author: "BuilderBro Team",
    role: "Construction Services",
    company: "BuilderBro",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/4ou14bgk_builderbro.png",
    color: "#6C4DF6"
  },
  {
    id: 2,
    text: "Working with Maheen has been a great experience. She understands both design and marketing, which helped us improve our website performance and overall user experience.",
    author: "Innovative Facades",
    role: "Architecture Firm",
    company: "Innovative Facades",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/oqtndpg5_Screenshot%202026-04-13%20141305.png",
    color: "#9D7BFF"
  },
  {
    id: 3,
    text: "Maheen is highly dedicated and detail-oriented. From content updates to running ad campaigns, she handles everything professionally and delivers consistent results.",
    author: "The Leather Saga",
    role: "E-commerce Client",
    company: "The Leather Saga",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/tsvor702_Screenshot%202026-04-13%20141418.png",
    color: "#C6B6FF"
  },
  {
    id: 4,
    text: "Her expertise in both technical development and digital marketing makes her invaluable. The website redesign and marketing campaigns exceeded our expectations.",
    author: "Prajwal Constructions",
    role: "Construction Company",
    company: "Prajwal Constructions",
    image: "https://customer-assets.emergentagent.com/job_digital-maheen/artifacts/yaixisyn_Screenshot%202026-04-13%20141454.png",
    color: "#6C4DF6"
  }
];

export const currentProject = {
  title: "Current Project – Digital Marketing & Web Management",
  company: "BuilderBro Construction",
  website: "builderbro.construction",
  description: "I am currently working on the website builderbro.construction, where I handle both website management and digital marketing activities.",
  activities: [
    "Managing and updating the WordPress website, including content updates and creating high-converting landing pages",
    "Implementing on-page SEO strategies such as keyword optimization, meta tags, image alt attributes, and internal linking to improve search visibility",
    "Planning and executing Facebook and Instagram ad campaigns to generate quality leads for construction and real estate services",
    "Optimizing website performance, including page speed, mobile responsiveness, and UI enhancements for a better user experience",
    "Creating and publishing marketing content, social media creatives, and promotional campaigns to strengthen brand presence",
    "Monitoring and analyzing campaign performance using Google Analytics and Meta Ads Manager to improve conversions and ROI",
    "Collaborating with developers and designers to align digital strategies with business goals"
  ],
  color: "#6C4DF6"
};
